import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    this.tomSelect = new TomSelect(this.element, {
      plugins: ["remove_button"],
      onChange: () => this.submitForm()
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
  }

  submitForm() {
    const form = this.element.form
    form.querySelectorAll("[data-contact-us-empty-marker]").forEach((element) => element.remove())

    if (this.tomSelect.getValue().length === 0) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "project[contact_us_recipient_admin_user_ids][]"
      input.value = ""
      input.dataset.contactUsEmptyMarker = "true"
      form.appendChild(input)
    }

    form.requestSubmit()
  }
}
